import { Col, Container, Row } from "react-bootstrap";
import { navigateTo } from "../../../redux/router/routerActions";
import { useAppDispatch } from "../../../redux/store";
import { useEditIntegrationMutation, useGetIntegrationByIdQuery } from "../../../services/bClientApi";
import { useParams } from "react-router-dom";
import IntegrationForm from "../../../Components/Forms/IntegrationForm/IntegrationForm";

export default function EditIntegrationPage() {

    const { integrationId = '' } = useParams()

    const {
        data: integrationData,
        error: getError,
        isLoading: getIsLoading
    } = useGetIntegrationByIdQuery(integrationId, { skip: !integrationId })

    const [
        editIntegration,
        {
            isLoading: editIsLoading,
            error: editError
        }
    ] = useEditIntegrationMutation()

    const dispatch = useAppDispatch()

    const handleSubmit = async (data: any) => {
        const values: any = { ...data }
        if (values.externalIds && typeof values.externalIds === 'string') {
            try { values.externalIds = JSON.parse(values.externalIds) } catch { values.externalIds = {} }
        }
        if (values.overrideData && typeof values.overrideData === 'string') {
            try { values.overrideData = JSON.parse(values.overrideData) } catch { values.overrideData = null }
        }
        const updatedIntegration = await editIntegration({
            integrationId,
            integrationInfo: values
        }).unwrap()
        if (updatedIntegration._id) {
            dispatch(navigateTo(`/integration/${updatedIntegration._id}`))
        }
        return updatedIntegration
    }

    const getInitialData = () => {
        if (!integrationData) return {}
        return {
            entityType: integrationData.entityType || '',
            entityId: integrationData.entityId || '',
            provider: integrationData.provider || '',
            primaryExternalId: integrationData.primaryExternalId || '',
            externalIds: integrationData.externalIds ? JSON.stringify(integrationData.externalIds, null, 2) : '',
            overrideData: integrationData.overrideData ? JSON.stringify(integrationData.overrideData, null, 2) : '',
            sync: {
                status: integrationData.sync?.status || '',
            }
        }
    }

    return (
        <Container>
            <Row>
                <Col>
                    <h1>Edit Integration</h1>
                    <hr />
                    {getError && (<>{JSON.stringify(getError)}<br /></>)}
                    {editError && (<>{JSON.stringify(editError)}<br /></>)}

                    {integrationData && integrationData._id && !getIsLoading && (
                        <IntegrationForm
                            initialData={getInitialData()}
                            disabled={editIsLoading}
                            onSubmit={handleSubmit}
                        />
                    )}
                </Col>
            </Row>
        </Container>
    )
}
